import { Favorite } from 'src/app/shared/models';

/**
 * Convenience class that splits a favorite's text in chunks, so that
 * the template can highlight the parts of the favorites were the search term appear
 */
export class FavoriteSuggestion {
  favorite: Favorite;
  sortWeight: number;
  doesStartWithTerm = false;
  preview: string; // needs to start with what was typed, so that the preview stays exactly below the typed text
  chunks: {
    text: string;
    isHighlighted: boolean;
  }[];

  constructor(favorite: Favorite, normalizedTerm: string, termAsTyped: string) {
    this.favorite = favorite;
    this.buildChunks(normalizedTerm);
    this.computeSortWeight();
    if (this.doesStartWithTerm) {
      this.preview = `${termAsTyped}${(favorite.editorModel?.text || '').substring(termAsTyped.length)}`;
    }
  }

  private buildChunks(normalizedTerm: string) {
    this.chunks = [];
    const splitted = this.favorite.normalizedText.split(normalizedTerm);
    let startOfCurrentChunk = 0;
    for (let i = 0; i < splitted.length - 1; i++) {
      const chunkLength = splitted[i].length;
      this.pushChunk(startOfCurrentChunk, chunkLength, false);
      startOfCurrentChunk += chunkLength;
      if (startOfCurrentChunk === 0) {
        this.doesStartWithTerm = true;
      }
      this.pushChunk(startOfCurrentChunk, normalizedTerm.length, true);
      startOfCurrentChunk += normalizedTerm.length;
    }
    this.pushChunk(startOfCurrentChunk, splitted[splitted.length - 1].length, false);
  }

  private pushChunk(start: number, length: number, isHighlighted) {
    this.chunks.push({
      text: (this.favorite.editorModel?.text || '').substring(start, start + length),
      isHighlighted,
    });
  }

  private computeSortWeight() {
    const highlightedLength = this.chunks
      .filter(chunk => chunk.isHighlighted)
      .map(chunk => chunk.text.length)
      .reduce((acc, cur) => acc + cur, 0);
    const totalLength = this.favorite.normalizedText.length;
    this.sortWeight = totalLength ? highlightedLength / totalLength : 0;
  }
}
